const API_BASE = process.env.NODE_ENV === 'production' ? window.location.origin : 'http://localhost:3000'

const get = (path) => fetch(`${API_BASE}/${path}`)
    .then(r => r.json())
    // .catch(console.warn)
    // NOTE: needsto be disabled for offline handling
    // TODO: improve offline handling with service worker (eg. cache response instead of custom)

const post = (path, data) => {
    return fetch(`${API_BASE}/${path}`, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
            'Content-type': 'application/json',
        },
    }).then(r => r.json())
    .catch(console.error)
}

export { get, post }
